function MouseFollower({ x, y }: { x: number; y: number }) {
  return (
    <div
      className="fixed w-96 h-96 rounded-full pointer-events-none z-0 transition-all duration-500 ease-out opacity-20 blur-3xl"
      style={{
        left: x - 192,
        top: y - 192,
        background:
          "radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, transparent 70%)",
      }}
    />
  );
}

export default MouseFollower;